import { apiSlice } from "./apiSlice";
export const actionTrackerCommentSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getActionComments: builder.query({
            query: (id) => ({
                url: `ProjectActionHistory/action/${id}`,
                // params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["AllActionTracker"],
        }),
    }),
});

export const { useGetActionCommentsQuery } = actionTrackerCommentSlice;
